import loadable from '@loadable/component';
export const manifest = {
  'SmeStorage.Get': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeStorageGet";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeStorageGet" */
          './get'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./get");
            }

            return eval('require.resolve')("./get");
          }

        }, {
          resolveComponent: m => m.SmeStorageGet
        })
      }
    }
  },
  'SmeStorage.Set': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "SmeStorageSet";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "SmeStorageSet" */
          './set'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./set");
            }

            return eval('require.resolve')("./set");
          }

        }, {
          resolveComponent: m => m.SmeStorageSet
        })
      }
    }
  }
};